import React from 'react';
import Alert from "react-bootstrap/Alert";

import BaseWidget from '../base-widget/BaseWidget';
import {SchemaContext} from "../../schema/context/SchemaContext";
import ManageSchema from "../../../pages/schema/ManageSchema";
import OpenSchemaAction from "../../schema/actions/OpenSchemaAction";
import Loader from "../../loader/Loader";

class ActiveSchemaWidget extends React.Component {

  static contextType = SchemaContext;

  render() {
    return (
      <BaseWidget className="ActiveSchemaWidget" title='Active Schema'>
        {
          this.context.loading && <Loader size='lg' block={true}/>
        }
        {
          !this.context.loading && !this.context.schema &&
          <Alert variant="warning" className="NoActiveSchemaAlert">No active schema found</Alert>
        }
        {
          this.context.schemaId &&
          <OpenSchemaAction standardButton={true} schemaId={this.context.schemaId}/>
        }
        <ManageSchema schemaId={this.context.schemaId}/>
      </BaseWidget>
    );
  }
}

export default ActiveSchemaWidget;
